module.exports = __webpack_public_path__ + "img/dkncloudimage.dbb52f0b.png";